// Süper admin › Katalog › Yeni / Düzenle katalog ürünü penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.catalogProduct';

export const catalogProductGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Katalog ürünü nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Ortak ürün kataloğuna tek bir ürün ekler ya da var olan ürünü düzenlersiniz. Şirketler bu katalogdan seçtikleri ürünleri kendi stoklarına aktarır; buradaki ad, barkod, katalog kodu, birim, KDV ve ÖKC departman bilgisi aktarılan stok kartına kopyalanır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yeni / Düzenle'),
    body: t(`${G}.regions.body`, 'Ürün bilgileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Ad, barkod ve katalog kodu'),
      text: t(`${G}.s1.text`, '"Ürün Adı" zorunludur. Barkod alanından çıktığınızda barkod katalogda aranır; başka bir üründe kayıtlıysa hangi ürün olduğu alanın altında yazar ve Kaydet düğmesi kapanır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Aynı barkod katalogda iki üründe olamaz.'),
        t(`${G}.s1.tip2`, 'Katalog Kodu, şirket ürünü stoğuna aldığında stok kodu olarak kullanılır; boşsa stok kodu "KTL-<katalog no>" şeklinde üretilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Sektör, kategori ve birim'),
      text: t(`${G}.s2.text`, '"Sektör" seçimi zorunludur. Kategori listesi seçilen sektöre göre açılır (alt kategoriler girintili görünür); sektörü değiştirirseniz seçili kategori temizlenir. Birim listeden seçilir (Adet, Kg, Koli, Teneke); listede yoksa yazabilirsiniz, boş bırakılırsa "Adet" kaydedilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. KDV oranı ve KDV durumu'),
      text: t(`${G}.s3.text`, '"KDV Oranı" ve "KDV Durumu" (Kdv Dahil / Kdv Hariç) şirketin stok kartına aynen geçer ve satışta vergi hesabını belirler. Yeni üründe varsayılan %20 ve Kdv Dahil\'dir; doğru olduğundan emin olun.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. ÖKC departman no, görsel ve durum'),
      text: t(`${G}.s4.text`, '"ÖKC Departman No" (1–8) yazar kasada ürünün hangi departmana gideceğini belirtir; isteğe bağlıdır. "Görsel Adresi"ne resmin internet adresini yazın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Pasif yapılan ürün şirketlere katalogda hiç gösterilmez.'),
        t(`${G}.s4.tip2`, 'Katalogda fiyat tutulmaz; şirket ürünü kendi stoğuna alırken satış fiyatını kendisi girer.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" ürünü oluşturur ya da günceller ve liste yenilenir. Barkod kontrolü sürerken veya barkod çakışması varken Kaydet kullanılamaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Katalogda yaptığınız değişiklik, şirketlerin daha önce stoğuna aktardığı ürünleri değiştirmez; yalnız sonraki aktarımlara yansır.'),
      ],
    },
  ],
});
